import { render, staticRenderFns } from "./link-contact-details.vue?vue&type=template&id=028ef0b2&scoped=true&"
import script from "./link-contact-details.vue?vue&type=script&lang=js&"
export * from "./link-contact-details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028ef0b2",
  null
  
)

export default component.exports